import {AbstractDataApiPlugin, PluginSettings} from './abstract-data-api-plugin';

/**
 * Base for a group plugin.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractGroup<T extends any, S extends PluginSettings> extends AbstractDataApiPlugin<S> {
  constructor(container: HTMLElement) {
    super(container);
  }
}
